<script>
import {dataLayerEvent} from "@utils/data-layer";
import store from "@state/store";
import UiButton from "@components/ui/ui-button/ui-button.vue";

export default {
    name: "JustTry",
    components: {UiButton},
    props: {
        imgNum: {
            type: Number,
            default: 1
        },
        serviceName: {
            type: String,
            default: ""
        },
        serviceSubtitle: {
            type: String,
            default: ""
        },
        buttonText: {
            type: String,
            default: "Попробовать"
        },
        buttonTextTranslit: {
            type: String,
            default: 'poprobovat'
        },
        buttonLinkToGeoeffect: {
            type: Boolean,
            default: false
        },
        isMobile: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        buttonClickEvent() {
            event.preventDefault();
            dataLayerEvent({
                eventId: 9,
                event: 'vntGeo',
                eventCategory: 'glavnaya',
                eventAction: 'button_click',
                buttonLocation: 'just-try',
                eventLabel: this.buttonTextTranslit
            });

            if (this.buttonLinkToGeoeffect && this.isMobile) {
                store.dispatch('modal/setActiveModalWindow', 'MobileBlock')
                return;
            }

            const target = event.target.closest('#just-try-btn');
            if (target) {
                const loader = document.getElementById('preloading-spinner-wrap');
                loader.style = 'display: flex;';

                setTimeout(() => {
                    window.location.href = target.href;
                }, 3000)
            }
        }
    }
}
</script>

<template>
    <div id="just-try" class="just-try">
        <div class="just-try-text">
            <div class="just-try-title">{{ serviceName }}</div>
            <div
                v-if="serviceSubtitle"
                class="just-try-subtitle"
            >
                {{ serviceSubtitle }}
            </div>
        </div>
        <div
            :class="`just-try-note-${imgNum}`"
            class="just-try-note"
        ></div>
        <div class="just-try-button-container">
            <UiButton
                v-if="buttonLinkToGeoeffect"
                id="just-try-btn"
                size="medium"
                color="primary"
                href="https://system.geoeffect.ru/geoeffect_promo"
                @click="buttonClickEvent"
            >
                {{ buttonText }}
            </UiButton>
            <div
                v-else
                class="ui-button primary granat filled medium d-inline-block"
                data-product="GeoEffect"
                data-vitrine="Геоэффект"
                data-btn-view="hidden"
                data-bo-hw-lead-button="true"
                data-bo-required-inn="true"
                data-bo-not-required="email"
                data-bo-subline=""
                :data-btn-text="buttonText"
                @click="buttonClickEvent"
            >
                <p>
                    {{buttonText}}
                </p>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
    @import '@design/sections/just-try.scss';
</style>
